import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _objectDestructuringEmpty from "@babel/runtime-corejs2/helpers/esm/objectDestructuringEmpty";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
export var WM_LEGACY_TRIGGER = 'WM_LEGACY';
export var WelcomeMessagesLegacyTrigger = /*#__PURE__*/function () {
  function WelcomeMessagesLegacyTrigger(_ref, dependencies) {
    _objectDestructuringEmpty(_ref);

    _classCallCheck(this, WelcomeMessagesLegacyTrigger);

    _defineProperty(this, "dependencies", void 0);

    this.dependencies = dependencies;
  }

  _createClass(WelcomeMessagesLegacyTrigger, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.dependencies['account-actions'].onActionRequested(function (_ref2) {
                  var actionId = _ref2.actionId,
                      data = _ref2.data;

                  if (actionId === ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPEN) {
                    _this.dependencies['on-site-messaging-component'].requestMessage({
                      trigger: WM_LEGACY_TRIGGER,
                      data: data
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return WelcomeMessagesLegacyTrigger;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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